import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BuscarService } from 'src/app/services/buscar.service';
import { objClienteFrm } from 'src/app/modulos/archivos/interlocutor-comercial/cliente/cliente-nuevo/objConfiguracionCliente.model'
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion, obtenerFechaActual } from 'src/app/shared/utils';
import { Cliente } from 'src/app/models/cliente.model';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ClienteService } from 'src/app/services/cliente.service'
import { VendedorService } from 'src/app/services/vendedor.service';
import * as moment from "moment";
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { ClienteClase } from "src/app/models/ClienteClase.model";
import { CondicionesPago } from 'src/app/models/CondicionesPago.model';
import { ClienteContacto } from 'src/app/models/ClienteContacto.model';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service'
import { ContactoService } from 'src/app/services/contacto.service'
import { Contacto } from 'src/app/models/Contacto.model';
import { ClienteDirecciones } from 'src/app/models/ClienteDirecciones.model';
import { bancoService } from 'src/app/services/bancos.service'
import { MonedaService } from 'src/app/services/moneda.service'
import { ClienteEspecificaciones } from 'src/app/models/ClienteEspecificaciones.model';
import { ClienteBancos } from 'src/app/models/ClienteBancos.model';
import { ImportarSunatComponent } from 'src/app/shared/modals/importar-sunat/importar-sunat.component';
import { RecursosService } from 'src/app/services/recursos.service';
import { StorageService } from 'src/app/services/storage.service';
import { DecimalPipe } from '@angular/common';
import { ContactoFrmComponent } from 'src/app/shared/modals/contacto-frm/contacto-frm.component';
import { ModalDireccionEnvioComponent } from 'src/app/shared/modals/modal-direccion-envio/modal-direccion-envio.component';
import { ModalDireccionEnvioUbigeoComponent } from 'src/app/shared/modals/modal-direccion-envio-ubigeo/modal-direccion-envio-ubigeo.component';
import { DataService } from 'src/app/services/dataService.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsultaService } from 'src/app/services/consulta.service';
import { TrazabilidadComponent } from '../trazabilidad/trazabilidad.component';
import { objArticulo, objClaseCodigoDescripcion, objArticuloEspecificacion } from 'src/app/models/objarticulo.model'
import { ArticuloService } from 'src/app/services/articulo.service'
import { ModalBusquedaArticulosComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-articulos/modal-busqueda-articulos.component'
import { ProveedorService } from 'src/app/services/proveedor.service'
import { ImagenBase64 } from 'src/app/models/imagenBase64.model';
import { SunnatService } from 'src/app/services/sunat-service';
import { GuiaremisionService } from 'src/app/services/guiaremision.service';
import { CotizacionModel } from 'src/app/models/cotizacion.model';
import { ToastrService } from 'ngx-toastr';
import { EnviosFEService } from 'src/app/services/envios-fe.service';
import { DocumentoCabeceraService } from 'src/app/services/documento-cabecera.service';
import * as FileSaver from 'file-saver';
import { ModalDocumentosAdjuntosCabComponent } from 'src/app/shared/modals/modal-documentos-adjuntos-cab/modal-documentos-adjuntos-cab.component';
import { documentoService } from 'src/app/services/documento.service';
import { MdDocumentoComponent } from 'src/app/shared/modals/md-documento/md-documento.component';
import { SituacionService } from 'src/app/services/situacion.service'
@Component({
  selector: 'app-md-consulta-clientes',
  templateUrl: './md-consulta-clientes.component.html',
  styleUrls: ['./md-consulta-clientes.component.css']
})
export class MdConsultaClientesComponent implements OnInit {

  @ViewChild('selectInsertar') selectInsertar: ElementRef;
  @ViewChild('selectModificar') selectModificar: ElementRef
  @ViewChild('razon') razon: ElementRef;
  @ViewChild(MdConsultaClientesComponent) tableclases: MdConsultaClientesComponent | any;
  @ViewChild(MdConsultaClientesComponent) tablecondi: MdConsultaClientesComponent | any;
  @ViewChild(MdConsultaClientesComponent) tablecontactos: MdConsultaClientesComponent | any;
  @ViewChild(MdConsultaClientesComponent) tabledire: MdConsultaClientesComponent | any;
  @ViewChild(MdConsultaClientesComponent) tableespecificaciones: MdConsultaClientesComponent | any;
  @ViewChild(MdConsultaClientesComponent) tablebancos: MdConsultaClientesComponent | any;
  @ViewChild('selectTipoInventario') selectTipoInventario: ElementRef;
  @ViewChild('modificar') modificar: ElementRef;

  @Input() codIntelocutor:any;

  sessionInfo: any;
  //Vista - tipo -> 1 lista , 2 nuevo , 3 modificar 
  identidad: boolean = true;
  isnatural: boolean = true;
  vista: number = 1;
  tamanoidentidad: number;
  objCliente = new objClienteFrm();
  ParamDocumento = new Cliente();
  //llamar a servicios combo
  identidades: any = []
  vendedor: any = []
  titulolista: any = []
  tipopersona: any = []
  clienteRegimenes: any = []

  disabledInterlocutor: boolean = false;
  encontro: boolean = false;

  codigoCliente: any = [];

  public interlocutores: any[] = [];

  public mostrar: boolean = false;

  clientes: any = [];
  //Variables para Clase
  public codClase: number;
  public desClase: string;
  public codCodigoClase: number;
  public desCodigoClase: string;
  public tabVentas: boolean = false;
  disabledCodigosClaseCombo: boolean = true;
  //Variables Modificar Clase
  editinputcla: any;
  editinputdescla: any;
  editinputcodigo: any;
  editinputdescodigo: any;
  editclase: any;
  editcond: any;
  editcontacto: any;
  editbanco: any;
  editespecificacion: any;
  //lista para clases
  clases = [];
  //lista para las condiciones de PAgo
  condicionesPago = [];
  //lista para contactos
  contactos = [];
  //lista para especificaciones
  especificaciones = [];
  //lista para direcciones de envío
  direcciones = [];
  //lista para bancos
  bancos = [];

  //combo para clases
  listaclases = [];
  listacodigos = [];
  listacondpago = [];

  financieras: any = [];
  tipocuentas: any = [];
  monedas: any = [];

  //  especificacion
  especificacion: any = [];
  //Checks de condicion de pago
  public codCondicionPago: number;
  public desCondicionPago: string;
  public predeterminado: boolean;
  public activo: boolean;
  //Modificar condiciones de pago
  public codCondicionPagoUpd: number;
  public desCondicionPagoUpd: string;
  public predeterminadoUpd: boolean;
  public activoUpd: boolean;

  //Atributos para crear direccion envío
  public codEnvio: number;
  public desEnvio: string = '';
  public direccionE1: string = '';
  public referenciaEnvio: string = '';
  public telefonoEnvio: string = '';
  public codEanEnvio: string = '';
  public celularEnvio: string = '';


  codBanco: number = null;
  desBanco: string = '';
  codTipoCuenta: number = null;
  desTipoCuenta: string = '';
  codMoneda: string = '';
  desMoneda: string = '';
  desCuenta: string = '';

  public disabledBotonBanco: boolean = true;
  public disabledTipoCuenta: boolean = true;
  public disabledMoneda: boolean = true;


  tident: string = '';
  //Clase temporal a guardar
  ClaseTemp = new ClienteClase()
  CondicionTemp = new CondicionesPago()
  EspecifiacionTemp = new ClienteEspecificaciones()
  DireccionTemp = new ClienteDirecciones()
  BancoTemp = new ClienteBancos()

  public clasesSelect: any[] = [];
  public mostrarTab: boolean = true;
  public disabledCliente: boolean = false;
  public flagDisabledButtons = true;

  public progressDirec1: string = '0%';
  public progressDirec2: string = '0%';
  public buscarLimpiarBoton: string = 'buscar';


  public disabledGuardar: boolean = true;


  closeResult = '';


  public tabModificar: boolean = false;
  public tabClases: boolean = true;
  public tabCondicionesPago: boolean = true;
  public tabCreditos: boolean = true;
  public tabContactos: boolean = true;
  public tabDireccionesEnvio: boolean = true;
  public tabEspecificaciones: boolean = true;
  public tabBanco: boolean = true;

  public _sunatImage: any = {};

  //ESPECIFICACION
  tipoConfirmar: string = 'Insert';
  //ENTRADAS
  public codEspecificacion: number;
  public desEspecificacion: string;
  public decimal: number;
  public texto: string;
  public caracter: string;
  public fecha: string;
  public tiempo: string;
  public numero: number;
  //MODALS DE DISABLED
  public disabledDecimal: boolean;
  public disabledTexto: boolean;
  public disabledCaracter: boolean;
  public disabledFecha: boolean;
  public disabledTiempo: boolean;
  public disabledNumero: boolean;

  //ATRIBUTOS DE MODIFICARBANCO

  codBancoUpd: number = null;
  desBancoUpd: string = '';
  codTipoCuentaUpd: number = null;
  desTipoCuentaUpd: string = '';
  codMonedaUpd: string = '';
  desMonedaUpd: string = '';
  desCuentaUpd: string = '';

  //ATRIBUTOS DIRECCION ENVIO
  codInterlocutor: string;
  codEnvioUpd: number;
  desEnvioUpd: string;
  direccionE1Upd: string;
  referenciaEnvioUpd: string;
  telefonoEnvioUpd: string;
  codEanEnvioUpd: string;
  celularEnvioUpd: string;
  botonUbigueoDireccionEnvio: boolean;

  //ATRIBUTOS ESPECIFICACIONES
  public disabledDecimalUpd: boolean = true;
  public disabledTextoUpd: boolean = true;
  public disabledCaracterUpd: boolean = true;
  public disabledFechaUpd: boolean = true;
  public disabledTiempoUpd: boolean = true;
  public disabledNumeroUpd: boolean = true;

  codEspecificacionUpd: number = null;
  desEspecificacionUpd: string = '';
  decimalUpd: number = null;
  textoUpd: string = '';
  caracterUpd: string = '';
  fechaUpd: string = '';
  tiempoUpd: string = '';
  numeroUpd: number = null;

  public _recursos: any = {};
  public _recursos1:any ={};
  //public sessionInfo: any = null;

  decimalPrecio: any = 2;
  viewlimiteCredito: any = 0;

  _monedaFactor: string = "S/";

  Ubigeobloc: boolean = false;
  titulocliente: any;
  @Input() buscar: boolean;
  @Input() codigocliente: any;

  cotizaciones: any = [];
  pedidos: any = [];
  facturas: any = [];
  boletas: any = [];

  _codSucursal: number = -1;
  public situaciones: any[] = [];
  public situaciones2: any[] = [];
  public newSituaciones: any[] = [];
  public newSituaciones2: any[] = [];

  public check: boolean = false;
  public check2: boolean = false;
  //VARIABLES FECHA
  public fechaDesde: any
  public fechaHasta: any;
  public desde: any
  public fechaHasta1: any;
  //Variables para busqueda por articulo
  disabledArticulo: boolean = false;
  public objarticulo = new objArticulo();
  articulos: any[] = [];
  tituloarticulo: any = '';
  public mostrarbotoneliminar: boolean = true
  public tabclases: boolean = false;
  public tabespecificaciones: boolean = false;
  public tabimagenes: boolean = false;
  public tabclasesglobales: boolean = false;
  public tablistprecios: boolean = false;
  public tabCotizaciones: boolean = false;
  public tabCompras: boolean = false;
  public tabLprecioProv: boolean = false;
  public tabComprometido: boolean = false;
  public tabXrecibir: boolean = false;
  disabledcampo: boolean = true;
  disabledProveedor: boolean = true;
  disabledTipoInventario: boolean = false;
  clasesGlobales: any[] = [];
  public codTipoInventario: number = 1;
  public imagenesArticulo: any[] = [];
  public tipoControlStock: any[] = [];
  public desControlStock: string = 'Controla stock unidades';
  public inputAgrupa: boolean;
  public inputPagoAdelantado: boolean;
  @ViewChild('selectunidadesMedidas') selectunidadesMedidas: ElementRef;
  buscarArticulo: string = 'buscar';
  @ViewChild('provee') provee: ElementRef;
  public updatebandera: boolean = false
  public desProveedor: String = ''
  buscarProveedor: string = 'buscar';
  listaPreciosArticulo: any[] = [];
  clasesSelectEspecificaciones = []
  listaStockPorAlmacen: any;
  stocktotalFisico: number = 0;
  stocktotalComprom: number = 0;
  stockTotalDisponi: number = 0;
  stockTotalPorRecibir: number = 0;
  stockTotalImportacion: number = 0;
  @ViewChild('desarticulo') desarticulo: ElementRef;
  public objImagen = new ImagenBase64();
  public codImagen: string = ''
  public disabledbotonImagen: boolean = true;
  sp_ventas: any[] = [];
  //VARIABLES TIPO DE INVENTARIO 
  public tiposInventario: any[] = [];
   
  //VARIABLES VENDEDOR
  public vendedores: any[] = [];
  public codVendedor: number = -1;
  //VARIABLES SUCURSAL
  public sucursales: any[] = [];
  public codSucursal: number = -1;
    //VARIABLES MOTIVO
    public motivos: any[] = [];
    public codMotivo: number = -1;
    //VARIABLES SUNAT
  public sunatlist: any[] = [];
  public codSunat: number = -1;

  public codLugarEmision: any;
  cotizacionmodel = new CotizacionModel();

  resultados: boolean = true;
  formulario: boolean = false;
  detalledocumento:any;
  constructor(
    private clienteService: ClienteService,
    private _buscarService: BuscarService,
    private spinnerService: SpinnerService,
    private VendedorService: VendedorService,
    private modalService: NgbModal,
    private interlocutorService: InterlocutorService,
    private CondicionPagoService: CondicionPagoService,
    private contactoService: ContactoService,
    private bancoService: bancoService,
    private MonedaService: MonedaService,
    private recursosService: RecursosService,
    private decimalPipe: DecimalPipe,
    public dataService: DataService,
    private trazabilidadService: ConsultaService,
    private modalService2: NgbActiveModal,
    private consultaService: ConsultaService,
    private articuloService: ArticuloService,
    private provedorService: ProveedorService,
    private SunnatService: SunnatService,
    private gremisionService: GuiaremisionService,
    private toastr: ToastrService,
    private enviosFEService: EnviosFEService,
    private docCabService: DocumentoCabeceraService,
    private documentoService:documentoService,
    private SituacionService: SituacionService

  ) { }

  ngOnDestroy() {
    this.dataService.vista = 0;

  }



  ngOnInit(): void {
    this.encontro = true;
    this.disabledInterlocutor = false;
    console.log('ESTE ES EL CODIGO QUE LLEGA',this.codIntelocutor);
    console.log(this.buscar)
    if (this.buscar == true) {
      console.log(this.codigoCliente)
      this.getByCodInterlocutor(this.codigocliente);
    }
    if(this.codIntelocutor!=null){
      this.getByCodInterlocutor(this.codIntelocutor);
    }
    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.sessionInfo != null) {
      if (this.sessionInfo.factores != null)
        this._monedaFactor = this.sessionInfo.factores.monedaLimiteCreditoClientes
      console.log(this.sessionInfo);
      this.getSituacion();
      this.cargarSituaciones();
      this.getVendedor();
      this.getSucursal();
      this.getMotivos();
      this.getSunat();
      this.fechaDesde = obtenerFechaActual('YYYY-MM-DD')
      this.fechaHasta = obtenerFechaActual('YYYY-MM-DD')
      this.desde = obtenerFechaActual('YYYY-MM-DD')
      this.fechaHasta1 = obtenerFechaActual('YYYY-MM-DD')

    }

    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
    this.spinnerService.activarLoading(true);
    this.recursosService.recursosIC().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
      this._recursos = resp.body;
      if (this._recursos != null && this._recursos.personas != null)
        this.tipopersona = this._recursos.personas;
      if (this._recursos != null && this._recursos.identidades != null)
        this.identidades = this._recursos.identidades;
      if (this._recursos != null && this._recursos.vendedores != null)
        this.vendedor = this._recursos.vendedores;
      if (this._recursos != null && this._recursos.tituloListas != null)
        this.titulolista = this._recursos.tituloListas;
      if (this._recursos != null && this._recursos.impositivos != null)
        this.clienteRegimenes = this._recursos.impositivos;
      if (this._recursos != null && this._recursos.inventarios != null)
        this.tiposInventario = this._recursos.inventarios;

      this.obtenerListaClases();
      this.obtenerListaCondPago();
      //bancos
      this.ObtenerEntidad();
      this.ObtenerTipoCuentas();
      this.ObtenerMonedas();
      this.ObtenerEspecificaciones();
      
      //this.obtenerClientes();
     
    }, err => {
      this.spinnerService.activarLoading(false);
    });
    this.spinnerService.activarLoading(true);
    this.recursosService.recursosArticulo().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this._recursos1 = resp.body;

      if (this._recursos1 != null && this._recursos1.inventarios != null)
        this.tiposInventario = this._recursos1.inventarios;

      this.objarticulo = new objArticulo()

      this.objarticulo.tipinv = -1
      this.objarticulo.fmatri = obtenerFechaActual('YYYY-MM-DD')
      this.objarticulo.faccon = (Number.parseFloat('1').toFixed(4));
      this.objarticulo.consto = 1;
      this.objarticulo.codprv = '';
      this.objarticulo.codart ='';
      this.desProveedor = ''
      console.log('Si toma valor:' + this.objarticulo.fmatri)

      timerOut(5).then((value: any) => {
        if (value) { this.selectTipoInventario.nativeElement.focus(); }
      })

    }, err => {
      this.spinnerService.activarLoading(false);
    });
      if(this.articuloTodos==true){
        this.disabledArticulo=true;
      }
      this.dataGlosas = JSON.parse(StorageService.getData_v2("v_recursosGlosa"));
    
    for(let i=0;i<this.dataGlosas.length;i++){
      if(this.dataGlosas[i].idform=="frmConsultaClientes"){
        console.log("Encontrado");
         let camp=this.dataGlosas[i].columns;
         this.campos=camp.sort(this.SortArray);
         console.log(this.campos);
         for(let j=0;j<this.campos.length;j++){
          this.campos[j].width=this.campos[j].width + "px";
          console.log("Este es el width")
          console.log(this.campos[j].width);
         }
      }
     }
  }
  public dataGlosas: any;
  public campos:any
  SortArray(x:any,y:any){
    if (x.order < y.order) {return -1;}
    if (x.order > y.order) {return 1;}
    return 0;
  }
  situacCotizaciones() {

    this.situaciones = this.sessionInfo.situaciones.filter((item: any) => item.tipdoc == 100)
    for (let index = 0; index < this.situaciones.length; index++) {
      const tempdoc = this.situaciones[index];
      tempdoc.checked = false;
      this.situaciones[index] = tempdoc
    }
    this.CheckAllOptions();
    this.check = true;

  }

  situacFacturas() {


    this.situaciones = this.sessionInfo.situaciones.filter((item: any) => item.tipdoc == 1)
    for (let index = 0; index < this.situaciones.length; index++) {
      const tempdoc = this.situaciones[index];
      tempdoc.checked = false;
      this.situaciones[index] = tempdoc
    }
    this.CheckAllOptions();
    this.check = true;

  }

  situacPedidos() {
    this.situaciones = this.sessionInfo.situaciones.filter((item: any) => item.tipdoc == 101)
    for (let index = 0; index < this.situaciones.length; index++) {
      const tempdoc = this.situaciones[index];
      tempdoc.checked = false;
      this.situaciones[index] = tempdoc
    }
    this.CheckAllOptions();
    this.check = true;
  }

  situacboletas() {
    this.situaciones = this.sessionInfo.situaciones.filter((item: any) => item.tipdoc == 3)
    for (let index = 0; index < this.situaciones.length; index++) {
      const tempdoc = this.situaciones[index];
      tempdoc.checked = false;
      this.situaciones[index] = tempdoc
    }
    this.CheckAllOptions();
    this.check = true;
  }



  private cargarSituaciones() {
    this.spinnerService.activarLoading(true);

    this.situaciones = this.sessionInfo.situaciones.filter((item: any) => item.tipdoc == 100)
    for (let index = 0; index < this.situaciones.length; index++) {
      const tempdoc = this.situaciones[index];
      tempdoc.checked = false;
      this.situaciones[index] = tempdoc
    }
    this.CheckAllOptions();
    this.check = true;

  }
  private getSituacion() {
    this.spinnerService.activarLoading(true);
    this.SituacionService.buscarSituacion(102, '').subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.situaciones2 = resp.body.list;
      for (let index = 0; index < this.situaciones2.length; index++) {
        const tempdoc = this.situaciones2[index];
        tempdoc.checked = false;
        this.situaciones2[index] = tempdoc
      }
      this.CheckAllOptions2();
      this.check2 = true;
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }
  CheckAllOptions2() {
    console.log(this.situaciones2)
    if (this.situaciones2.every(val => val.checked == true)) {
      this.situaciones2.forEach(val => { val.checked = false });
      this.newSituaciones2 = [];
    } else {
      this.situaciones2.forEach(val => { val.checked = true });
      for (let index = 0; index < this.situaciones2.length; index++) {
        if (!this.newSituaciones2.includes(this.situaciones2[index].situac)) {
          this.newSituaciones2.push(this.situaciones2[index].situac);
        }
      }
    }
    console.log("seleccionado todos")
    console.log(this.newSituaciones2)
  }


  CheckAllOptions() {
    console.log(this.situaciones)
    if (this.situaciones.every(val => val.checked == true)) {
      this.situaciones.forEach(val => { val.checked = false });
      this.newSituaciones = [];
    } else {
      this.situaciones.forEach(val => { val.checked = true });
      for (let index = 0; index < this.situaciones.length; index++) {
        if (!this.newSituaciones.includes(this.situaciones[index].situac)) {
          this.newSituaciones.push(this.situaciones[index].situac);
        }
      }
    }
    console.log("seleccionado todos")
    console.log(this.newSituaciones)
  }



  ObtenerEspecificaciones() {
    this.interlocutorService.getEspecificaciones().subscribe(response => {

      this.especificacion = response.body;
    })
  }

  ObtenerEntidad() {
    this.bancoService.obtenerEntidad().subscribe(response => {

      this.financieras = response.body;
    })
  }
  ObtenerTipoCuentas() {
    this.bancoService.obtenerTipoCuentas().subscribe(response => {

      this.tipocuentas = response.body;
    })

  }

  ObtenerMonedas() {
    this.MonedaService.buscar().subscribe(response => {

      this.monedas = response.body.list;
    })

  }

  obtenerListaClases() {
    this.clienteService.buscarClases().subscribe(response => {

      this.listaclases = response.body;
    })

  }

  obtenerListaCondPago() {
    this.CondicionPagoService.busar("", true).subscribe(response => {
      this.listacondpago = response.body.list;
    })
  }

  onChangeClases(clase: any) {
    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;
    this.obtenerListaClasesCodigos(clase);
  }
  obtenerListaClasesCodigos(clase: any) {
    this.clienteService.buscarCodigos(clase).subscribe(response => {

      this.listacodigos = response.body;
    })

  }



  modificarUbigeoclases() {
    const referenciaModal = this.modalService.open(ModalDireccionEnvioUbigeoComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);
      if (this.clases == null)
        this.clases = [];
      if (data != null) {
        data.forEach(element => {
          this.clases.push(element);
        });
      }
      if (this.clases.find(x => x.clase == 14) == null) {
        // basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
        //obteniendo la descripcion del codigo en desCodigoClase
        console.log("CLASE CLASES 132")
        this.Ubigeobloc = false;
      }
      else {
        this.Ubigeobloc = true;
      }
    }, (reason) => {
      console.log(reason);
    });
  }


  cancelarInsercion() {
    this.ParamDocumento = new Cliente();
    this.borrarDatos();
    this.vista = 1;
    this.mostrar = false;
    this.buscarLimpiarBoton = 'buscar';
    this.dataService.vista = 0;

    this.mostrar = false;
    this.disabledInterlocutor = false;
    this.encontro = true;

    //this.dtTrigger.next();
    //this.dtTrigger.next();
  }
  borrarDatos() {
    this.encontro = true;
    this.disabledInterlocutor = false;
    this.encontro = true;

    this.objCliente = new objClienteFrm();
    this.disabledGuardar = true;
    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");

    setTimeout(() => {
      $('#codTipoDocumento').focus();
    }, 150);
  }

  public messageTable = {
    emptyMessage: 'No hay información',
    totalMessage: 'total',
    selectedMessage: 'selected'
  }
  modificarCliente() {
    /*
    if (this.objAlmacen.codalm == null) {
      basicAlert('El campo "Código" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    } else if (this.objAlmacen.tipinv == '' || this.objAlmacen.tipinv == null) {
      //this.funicionesTSIService.alertSweetFocusInput('La descripción es obligatoria', 'warning', '#descripcion');
      basicAlert('El campo "Tipo de inventario" es obligatorio', 'warning', 'Aceptar', null, null);
      return;
    }

    this.sucursales.forEach(element => {
      if (element.codsuc == this.inputclase) {
        this.desputclase = element.sucursal;
      }
    });

    */

    this.ParamDocumento.id_cia = this.objCliente.id_cia;
    this.ParamDocumento.tipopersona = this.objCliente.tipopersona;
    this.ParamDocumento.valident = this.objCliente.valident;
    this.ParamDocumento.tident = this.objCliente.tident;
    this.ParamDocumento.codcli = this.objCliente.codcli;
    this.ParamDocumento.nombrescompletos = this.objCliente.nombrescompletos;
    this.ParamDocumento.direc1 = this.objCliente.direc1;
    this.ParamDocumento.direc2 = this.objCliente.direc2;
    this.ParamDocumento.apellidopaterno = this.objCliente.apellidopaterno;
    this.ParamDocumento.email = this.objCliente.email;
    this.ParamDocumento.apeliidomaterno = this.objCliente.apeliidomaterno;
    this.ParamDocumento.telefono = this.objCliente.telefono;
    this.ParamDocumento.nombres = this.objCliente.nombres;
    this.ParamDocumento.fax = this.objCliente.fax;
    this.ParamDocumento.nrodni = this.objCliente.nrodni;
    this.ParamDocumento.sexo = this.objCliente.sexo;
    this.ParamDocumento.titulolista = this.objCliente.titulolista;
    this.ParamDocumento.codven = this.objCliente.codven;
    this.ParamDocumento.exoimp = this.objCliente.exoimp;
    this.ParamDocumento.regret = this.objCliente.regret;
    this.ParamDocumento.observ = this.objCliente.observ;
    this.ParamDocumento.codtit = this.objCliente.codtit;
    this.ParamDocumento.codtpe = this.objCliente.codtpe;
    this.ParamDocumento.razonc = this.objCliente.razonc;
    this.ParamDocumento.dident = this.objCliente.dident;
    this.ParamDocumento.fecing = moment(this.objCliente.fecing).format("YYYY-MM-DD");
    this.ParamDocumento.clases = this.clases;
    this.ParamDocumento.regret = this.objCliente.regret;
    this.ParamDocumento.contactos = this.contactos;
    this.ParamDocumento.condicionespago = this.condicionesPago;
    this.ParamDocumento.especificaciones = this.especificaciones;
    this.ParamDocumento.direccionesenvio = this.direcciones;
    this.ParamDocumento.bancos = this.bancos;
    this.ParamDocumento.codpag = +this.objCliente.credito;

    this.ParamDocumento.diasgracia = this.objCliente.diasgracia;
    this.ParamDocumento.limiteCredito = this.objCliente.limiteCredito;


    this.spinnerService.activarLoading(true);
    this.clienteService.actualizarCliente(this.ParamDocumento).subscribe(response => {
      this.spinnerService.activarLoading(false);


      this.disabledInterlocutor = false;
      this.encontro = true;
      if (response.status === 200) {
        basicAlert('Se modificó correctamente.', 'success', 'Aceptar', null, null);
        this.borrarDatos();
        this.buscarLimpiarBoton = 'buscar';
        this.dataService.vista = 0;

        this.mostrar = false;
        this.ParamDocumento = new Cliente();
        this.vista = 1;
      }
    }, error => {
      this.spinnerService.activarLoading(false);

      basicAlert(error.error, 'error', 'Aceptar');
    }
    );
  }
  onKeyEnterCodInterlocutor(e: any) {
    this.onBlurCodInterlocutor(this.objCliente.codcli);
  }

  onKeyEnterInterlocutor(e) {
    this.openModalInterlocutor();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurCodInterlocutor(codcli: string) {
    if (codcli != null || codcli != '') {
      this.getByCodInterlocutor(codcli);
    }
  }

  getByCodInterlocutor(codcli: string) {

    this.codigoCliente = codcli;
    this.spinnerService.activarLoading(true);
    this.interlocutorService.obtenerInterlocutor(codcli, null).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.mostrar = true;


      this.disabledInterlocutor = true;
      this.encontro = false;


      this.objCliente.codcli = response.body.codcli;
      this.objCliente.razonc = response.body.razonc;
      this.titulocliente = response.body.razonc;
      this.objCliente.codtpe = response.body.codtpe;
      this.objCliente.fecing = response.body.fecing != null ? response.body.fecing : moment(new Date()).format("YYYY-MM-DD");;
      this.objCliente.valident = response.body.valident;
      this.objCliente.tident = response.body.tident;
      this.objCliente.dident = response.body.dident != null ? response.body.dident : '';
      this.objCliente.razonc = response.body.razonc != null ? response.body.razonc : '';
      this.objCliente.direc1 = response.body.direc1 != null ? response.body.direc1 : '';
      this.objCliente.direc2 = response.body.direc2 != null ? response.body.direc2 : '';
      this.objCliente.apellidopaterno = response.body.apellidopaterno != null ? response.body.apellidopaterno : '';
      this.objCliente.apeliidomaterno = response.body.apeliidomaterno != null ? response.body.apeliidomaterno : '';
      this.objCliente.nombres = response.body.nombres != null ? response.body.nombres : '';
      this.objCliente.email = response.body.email != null ? response.body.email : '';
      this.objCliente.telefono = response.body.telefono != null ? response.body.telefono : '';
      this.objCliente.fax = response.body.fax != null ? response.body.fax : '';
      this.objCliente.nrodni = response.body.nrodni != null ? response.body.nrodni : '';
      this.objCliente.sexo = response.body.sexo;
      this.objCliente.codven = response.body.codven;
      this.objCliente.codtit = response.body.codtit;
      this.objCliente.regret = response.body.regret;
      this.objCliente.observ = response.body.observ;
      this.objCliente.codpag = response.body.codpag;
      this.objCliente.exoimp = response.body.exoimp;
      this.objCliente.regret = response.body.regret;

      if (response.body.codpag == 0) {
        this.objCliente.credito = "0"
      }
      if (response.body.codpag == 1) {
        this.objCliente.credito = "1"
      }
      this.viewlimiteCredito = 0;
      this.objCliente.limiteCredito = response.body.limiteCredito;
      if (this.objCliente.limiteCredito != null && this.objCliente.limiteCredito > 0) {
        this.viewlimiteCredito = this.decimalPipe.transform(this.objCliente.limiteCredito, `0.${this.decimalPrecio}-${this.decimalPrecio}`);
      }

      this.objCliente.diasgracia = response.body.diasgracia;

      this.progressDirec1 = this.objCliente.direc1.length + '%';
      this.progressDirec2 = this.objCliente.direc2.length + '%';

      this.clases = response.body.clases;

      console.log("CLASE CLASES")
      console.log(response.body.clases)
      /*
      if(this.clases.clase==14){
        this.Ubigeobloc=true;
      }
      */

      if (this.clases.find(x => x.clase == 14) == null) {
        // basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
        //obteniendo la descripcion del codigo en desCodigoClase
        console.log("CLASE CLASES 132")
        this.Ubigeobloc = false;
      }
      else {
        this.Ubigeobloc = true;
      }

      this.condicionesPago = response.body.condicionespago;
      this.contactos = response.body.contactos;
      this.especificaciones = response.body.especificaciones;
      this.direcciones = response.body.direccionesenvio;
      this.bancos = response.body.bancos;

      this.onSelectTipoPersonaIns(this.objCliente.codtpe);

      this.buscarLimpiarBoton = 'borrar';
      this.dataService.vista = 1;
      this.dataService.tipo = 'cliente';

      this.disabledCliente = true;
      this.mostrarTab = false;
      this.flagDisabledButtons = false;
      this.selectModalNuevo();
      setTimeout(() => {
        $('#cboTipoPersona').focus();
      }, 150);


    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 404) {
        basicAlert('Cliente no encontrado', 'warning', 'Aceptar');
      }
      setTimeout(() => {
        //this.chRef.detectChanges();
        //this.funicionesTSIService.createTable('datatableContacto', false, true, '350px');
        //this.funicionesTSIService.createTable('datatableBancos', false, true, '350px');
        //this.funicionesTSIService.createTable('datatableDireccionesEnvio', false, true, '350px');
      }, 350);
    });

  }

  openModalInterlocutor() {

    let codcli: string = '';
    let razonc: string = this.objCliente.razonc + "%";
    let nombres: string = '';
    let dident: string = '';
    let soloactivos: boolean = true;
    let limit: number = 350;
    let offset: number = 0;

    this.ParamDocumento.razonc = this.objCliente.razonc;

    if (this.objCliente.razonc.length > 0) {
      this.spinnerService.activarLoading(true);

      //this.funicionesTSIService.destroyTable('ModaldatatableInterlocutor');
      this.interlocutorService.buscarInterlocutor(codcli, razonc, nombres, dident, soloactivos, limit, offset).subscribe((response: any) => {
        this.interlocutores = response.body;
        this.mostrarModalInterlocutor();

      }, err => {
        if (err.status == 404) {
          basicAlert('No se encontró la lista de clientes', 'warning', 'Aceptar', null, null, this.razon);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter', 'warning', 'Aceptar', null, null, this.razon);
      return;
    }
  }



  onChangeSituacs(option: string, isChecked: boolean) {
    if (isChecked) {
      this.newSituaciones.push(option);
    } else {
      this.newSituaciones = this.newSituaciones.filter(s => s !== option);
      this.check = false;
    }

    if (this.newSituaciones.length == this.situaciones.length) {
      this.check = true
    }
    console.log(this.newSituaciones)
  }

  buscarCotizaciones() {

    let vParams: any = {
      situac: this.newSituaciones.toString(),
      codsuc: this._codSucursal,
      codcli: this.objCliente.codcli,
      codven: -1,
      lugemi: -1,
      fdesde: this.fechaDesde,
      fhasta: this.fechaHasta,
      limit: 100,
      offset: 0
    };

    this.spinnerService.activarLoading(true);
    this.consultaService.buscarDocumentos(100, vParams).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.cotizaciones = resp.body;
    }, err => {
      this.cotizaciones = [];

      this.spinnerService.activarLoading(false);
      basicAlert('No hay resultados para los filtros seleccionados .', 'warning', 'Aceptar', null, null, null);
    })

  }


  buscarPedidos() {

    let vParams: any = {
      situac: this.newSituaciones.toString(),
      codsuc: this._codSucursal,
      codcli: this.objCliente.codcli,
      codven: -1,
      lugemi: -1,
      fdesde: this.fechaDesde,
      fhasta: this.fechaHasta,
      limit: 100,
      offset: 0
    };

    this.spinnerService.activarLoading(true);
    this.consultaService.buscarDocumentos(101, vParams).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.pedidos = resp.body;
    }, err => {
      this.pedidos = [];
      this.spinnerService.activarLoading(false);
      basicAlert('No hay resultados para los filtros seleccionados .', 'warning', 'Aceptar', null, null, null);
    })
  }



  trazabilidad(data: any) {
    this.spinnerService.activarLoading(true);
    this.trazabilidadService.getListTrazabilidadDocumentos(data.numint).subscribe((response: any) => {
      if (response.status != 404 && response.body.list != null && response.body.list.length > 0) {
        this.spinnerService.activarLoading(false);

        const referenciaModal = this.modalService.open(TrazabilidadComponent, { scrollable: true, windowClass: 'modal-lg-mytheme', backdrop: 'static' });
        referenciaModal.componentInstance.trazabilidades = response.body.list;
        referenciaModal.result.then((data) => {
          console.log(data);
        }, (reason) => {
          console.log(reason);
        });

      } else {
        this.spinnerService.activarLoading(false);
        basicAlert('Trazabilidad no disponible', 'warning', 'Aceptar', null, null, null);
      }
    });
  }



  buscarFacturas() {

    let vParams: any = {
      tipdoc: 1,
      situac: this.newSituaciones.toString(),
      codsuc: this._codSucursal,
      codcli: this.objCliente.codcli,
      codven: -1,
      lugemi: -1,
      fdesde: this.fechaDesde,
      fhasta: this.fechaHasta,
      limit: 100,
      offset: 0
    };

    this.spinnerService.activarLoading(true);
    this.consultaService.buscarDocumentos_v2(vParams).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.facturas = resp.body;
    }, err => {
      this.facturas = [];
      this.spinnerService.activarLoading(false);
      basicAlert('No hay resultados según los filtros seleccionados.', 'warning', 'Aceptar', null, null, null);
    })




  }


  buscarBoletas() {

    let vParams: any = {
      tipdoc: 3,
      situac: this.newSituaciones.toString(),
      codsuc: this._codSucursal,
      codcli: this.objCliente.codcli,
      codven: -1,
      lugemi: -1,
      fdesde: this.fechaDesde,
      fhasta: this.fechaHasta,
      limit: 100,
      offset: 0
    };

    this.spinnerService.activarLoading(true);
    this.consultaService.buscarDocumentos_v2(vParams).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.boletas = resp.body;
    }, err => {
      this.facturas = [];
      this.spinnerService.activarLoading(false);
      basicAlert('No hay resultados según los filtros seleccionados.', 'warning', 'Aceptar', null, null, null);
    })





  }

  mostrarModalInterlocutor() {
    const referenciaModal = this.modalService.open(ModalBusquedaInterlocutorComponent, { scrollable: true, windowClass: 'modal-lg-mytheme', backdrop: 'static' });
    referenciaModal.componentInstance.cabeceraTexto = 'comercial'
    referenciaModal.componentInstance.interlocutores = this.interlocutores;
    referenciaModal.result.then((data) => {

      this.getByCodInterlocutor(data.codcli);
      
    }, (reason) => {
      console.log(reason);
    });
  }
  //Predeterminado
  onChangePredeterminado(isChecked: boolean) {
    if (isChecked) {
      this.predeterminado = true;
    } else {
      this.predeterminado = false;
    }
  }
  //ACtivo
  onChangeActivo(isChecked: boolean) {
    if (isChecked) {
      this.activo = true;
    } else {
      this.activo = false;
    }
  }




  borrarDatosInterlocutor() {
    this.disabledInterlocutor = false;
    this.encontro = true;

    this.objCliente = new objClienteFrm();
    this.objCliente.fecing = moment(new Date()).format("YYYY-MM-DD");
    this.buscarLimpiarBoton = 'buscar';
    this.dataService.vista = 0;

    this.disabledCliente = false;
    this.interlocutores = [];
    this.clases = [];
    this.condicionesPago = [];
    this.especificaciones = [];
    this.contactos = [];

    this.direcciones = [];
    /*this.creditos = [];
    
    this.contactos = [];
    this.bancos = [];
    this.contactosAsignados = [];
    this.especificaciones = [];
    this.direccionesEnvio = [];
    */
    this.mostrarTab = true;
    this.flagDisabledButtons = true;


    this.tabModificar = false;
    this.tabClases = true;
    this.tabCondicionesPago = true;
    this.tabCreditos = true;
    this.tabContactos = true;
    this.tabEspecificaciones = true;
    this.tabDireccionesEnvio = true;
    //this.botonUbigueo = false;
    this.sp_ventas=[];
    $("#modificar-tab").addClass("active");
    $("#clases-tab").removeClass("active");
    $("#codpago-tab").removeClass("active");
    $("#creditos-tab").removeClass("active");
    $("#contacto-tab").removeClass("active");
    $("#especificacion-tab").removeClass("active");
    $("#direnvio-tab").removeClass("active");
    $("#banco-tab").removeClass("active");
    $('#datatableBancos').DataTable().destroy();
    setTimeout(() => {
      $('#desInterlocutor').focus();
    }, 250);

    this.cancelarInsercion();

  }

  onSelectTipoPersonaIns(codTpe: number) {

    if (codTpe == 1) {
      this.tident = "06"
    } else {
      this.tident = "999999"
    }
  }

  open1(content1: string) {
    this.modalService.open(content1, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  nuevoDireccionEnvio() {
    const referenciaModal = this.modalService.open(ModalDireccionEnvioComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.componentInstance.codcli = this.objCliente.codcli;
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);

      this.direcciones = [];
      this.spinnerService.activarLoading(true);
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.direcciones = response.body.direccionesenvio;
        console.log(this.direcciones);
      }, err => {
        this.spinnerService.activarLoading(false);
      });
    }, (reason) => {
      console.log(reason);
    });
  }

  // AbrirModificarDirecciones(content10 , item)
  editarDireccionEnvio(item: any) {

    this.spinnerService.activarLoading(true);
    this.interlocutorService.direccion_envio_obtener(this.objCliente.codcli, item.codenv).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      console.log(resp)

      const referenciaModal = this.modalService.open(ModalDireccionEnvioComponent, { backdrop: 'static', size: 'lg' });
      referenciaModal.componentInstance.editar = true;
      referenciaModal.componentInstance.codcli = this.objCliente.codcli;
      referenciaModal.componentInstance.DireccionTemp = resp.body;
      referenciaModal.result.then((data: any) => {

        console.log("view info success ")
        console.log(data);

        this.direcciones = [];
        this.spinnerService.activarLoading(true);
        this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          this.direcciones = response.body.direccionesenvio;
          console.log(this.direcciones);
        }, err => {
          this.spinnerService.activarLoading(false);
        });
      }, (reason) => {
        console.log(reason);
      });

    }, err => {
      this.spinnerService.activarLoading(false);

    })



  }


  open2(content2: string, cla: any) {

    this.disabledCodigosClaseCombo = false;
    this.listacodigos = [];
    this.codCodigoClase = null;

    this.editinputcla = cla.clase;
    this.editinputdescla = cla.desclase;
    this.obtenerListaClasesCodigos(cla.clase);
    this.editinputcodigo = cla.codigo;
    this.editinputdescodigo = cla.descodigo;
    this.editclase = cla;

    this.modalService.open(content2, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === 1) {
      return 'by pressing ESC';
    } else if (reason === 0) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  //Guardar Clase
  guardarClase() {

    if (this.codClase != null && this.codCodigoClase != null) {
      this.ClaseTemp = new ClienteClase();
      //obteniendo la descripcion de la clase en desClase
      this.ClaseTemp.clase = this.codClase;
      this.listaclases.forEach(element => {
        if (element.codigo == this.codClase) {
          this.desClase = element.descri;
        }
      });
      this.ClaseTemp.desclase = this.desClase;

      //Para saber si no existe
      if (this.clases.find(x => x.clase == this.ClaseTemp.clase) == null) {
        // basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
        //obteniendo la descripcion del codigo en desCodigoClase
        this.listacodigos.forEach(element => {
          if (element.codigo == this.codCodigoClase) {
            this.desCodigoClase = element.descri;
          }
        });

        //this.ClaseTemp.codmot =this.inputclase;
        this.ClaseTemp.codigo = this.codCodigoClase;
        this.ClaseTemp.descodigo = this.desCodigoClase;

        if (this.ClaseTemp.clase == 14) {
          this.Ubigeobloc = true;
        }
        else {
          this.Ubigeobloc = false;
        }

        this.clases.push(this.ClaseTemp);



      } else {
        basicAlert('El código de clase ya existe.', 'warning', 'Aceptar', null, null);
        return;
      }
      this.clases = [...this.clases]
      if (this.clases.find(x => x.clase == 14) == null) {
        this.Ubigeobloc = false;
        console.log("no hay 14")
      }
      else {
        this.Ubigeobloc = true;
        console.log("hay 14")
      }
      this.modalService.dismissAll();
      this.tableclases = this.clases;
      this.codClase = null;
      this.desClase = '';
      this.codCodigoClase = null;
      this.desCodigoClase = '';
      this.ClaseTemp = new ClienteClase();
      this.borrarDatosInset();
    } else {
      //En caso no se llenen los datos necesarios
      var dato = ''
      if (this.codClase == null) {
        dato = '"Clase"'
      } else if (this.codCodigoClase == null) {
        dato = '"Código"'
      }
      basicAlert("El campo " + dato + "es obligatorio.", 'warning', 'Aceptar');

    }


  }

  borrarDatosInset() {
    //this.disabledBotonClases = true;
    this.disabledCodigosClaseCombo = true;
    this.codClase = null;
    this.desClase = '';
    this.codCodigoClase = null;
    this.desCodigoClase = '';
    //DIRECCION ENVíO
    this.codEnvio = null;
    this.desEnvio = '';
    this.direccionE1 = '';
    this.referenciaEnvio = '';
    this.telefonoEnvio = '';
    this.codEanEnvio = '';
    this.celularEnvio = '';
    //BANCos
    this.disabledTipoCuenta = true;
    this.disabledMoneda = true;
    this.disabledBotonBanco = true;


    //this.childModalClases.hide();
  }
  closeInsert() {
    this.borrarDatosInset();
    this.tipoConfirmar = 'Insert';
  }
  //Actualizar Clase
  guardarActualizarClase() {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    console.log(this.sessionInfo)
    let arreglo = this.clases;
    let indice = arreglo.indexOf(this.editclase)



    arreglo[indice].clase = this.editinputcla;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.editinputcla) {
        this.editinputdescla = element.descri;
      }
    });
    //  
    arreglo[indice].desclase = this.editinputdescla;

    arreglo[indice].codigo = this.editinputcodigo;
    //
    this.listacodigos.forEach(element => {
      if (element.codigo == this.editinputcodigo) {
        console.log(element)
        this.editinputdescodigo = element.descri;
      }
    });
    //
    arreglo[indice].descodigo = this.editinputdescodigo;


    this.clases = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modalService.dismissAll();
  }
  //Almacenar cond. pago
  nuevaCondicionPago() {
    this.sessionInfo = JSON.parse(StorageService.getSession());
    if (this.codCondicionPago == null) {
      basicAlert("El campo 'Condicion de pago' es obligatorio.", 'warning', 'Aceptar');
      return;
    }

    //obteniendo la descripcion del codigo en codpag
    //Cambiar lista y los datos de element
    this.listacondpago.forEach(element => {
      if (element.codpag == this.codCondicionPago) {
        this.desCondicionPago = element.despag;
      }
    });

    this.CondicionTemp = new CondicionesPago();
    this.CondicionTemp.codpag = this.codCondicionPago;
    if (this.condicionesPago.find(x => x.codpag == this.CondicionTemp.codpag) == null) {

      if (this.sessionInfo != null) {
        this.CondicionTemp.usuari = this.sessionInfo.coduser;
      }

      this.CondicionTemp.despag = this.desCondicionPago;
      this.CondicionTemp.activo = this.activo;
      this.CondicionTemp.predeterminado = this.predeterminado;
      this.CondicionTemp.esNuevo = true;
      // this.CondicionTemp.usuario =this.sessionInfo.coduser,
      //this.response.emit(this.objInterlocutor);
      this.condicionesPago.push(this.CondicionTemp);

    } else {
      basicAlert('El código ya existe.', 'warning', 'Aceptar', null, null);
      return;
    }


    this.condicionesPago = [...this.condicionesPago]
    this.modalService.dismissAll();

    this.tablecondi = this.condicionesPago;

    this.codCondicionPago = null;
    this.desCondicionPago = '';
    this.activo = null;
    this.predeterminado = null;
    this.CondicionTemp = new CondicionesPago();
    this.borrarDatosInset();
  }

  onChangeActivoUpd(isChecked: boolean) {
    if (isChecked) {
      this.activoUpd = true;
    } else {
      this.activoUpd = false;

    }
  }

  onChangePredeterminadoUpd(isChecked: boolean) {
    if (isChecked) {
      this.predeterminadoUpd = true;
    } else {
      this.predeterminadoUpd = false;
    }
  }

  open4(content4: string, cla: any) {



    this.codCondicionPagoUpd = cla.codpag;
    this.desCondicionPagoUpd = cla.despag;
    //this.obtenerListaClasesCodigos(cla.clase);
    this.predeterminadoUpd = cla.predeterminado;
    this.activoUpd = cla.activo;
    this.editcond = cla;

    this.modalService.open(content4, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }

  guardarActualizarCondicion() {

    let arreglocond = this.condicionesPago;
    let indice = arreglocond.indexOf(this.editcond)

    arreglocond[indice].codpag = this.codCondicionPagoUpd;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.codCondicionPagoUpd) {
        this.desCondicionPagoUpd = element.descri;
      }
    });
    //  
    arreglocond[indice].despag = this.desCondicionPagoUpd;
    arreglocond[indice].predeterminado = this.predeterminadoUpd;
    arreglocond[indice].activo = this.activoUpd;

    this.condicionesPago = arreglocond
    // basicAlert('Se actualizo con éxito.', 'success', 'Aceptar', null, null);
    this.modalService.dismissAll();
  }


  _mNuevoContacto() {
    const referenciaModal = this.modalService.open(ContactoFrmComponent, { size: 'lg', backdrop: 'static' });
    referenciaModal.componentInstance.editar = false;
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);
      this.insertAsignarContacto(data.codcont);
    }, (reason) => {
      console.log(reason);
    });
  }

  _mEditarContacto(item: any) {

    let _contact: any = {};
    _contact.codcont = item.codcont;
    _contact.nomcont = item.nomcont;
    _contact.direccion = item.direccion;
    _contact.hobby = item.hobby;
    _contact.telefono = item.telefono;
    _contact.activo = item.activo;
    _contact.palabraclave = item.palabraclave;
    _contact.email = item.correo;
    _contact.cargo = item.cargo;

    const referenciaModal = this.modalService.open(ContactoFrmComponent, { size: 'lg', backdrop: 'static' });
    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.contacto = _contact;
    referenciaModal.componentInstance.codInterlocutor = this.objCliente.codcli;

    referenciaModal.result.then((data) => {
      if (data.actualizado != undefined && data.actualizado != null && data.actualizado) {
        this.contactos = [];
        this.spinnerService.activarLoading(true);
        this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          this.contactos = response.body.contactos;
        }, err => {
          this.spinnerService.activarLoading(false);
          console.log(err);
        });
      }
    }, (reason) => {
      console.log(reason);
    });
  }



  insertAsignarContacto(codcont: number) {
    this.spinnerService.activarLoading(true);
    this.interlocutorService.insertContactoInterlocutor(this.objCliente.codcli, codcont).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.borrarDatosInset();
      //this.response.emit();
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.contactos = response.body.contactos;
      }, err => {
        this.spinnerService.activarLoading(false);
        if (err.status == 404) {
          basicAlert(err.error, 'warning', 'Aceptar');
        }
      });

    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 404) {

        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      } if (err.status == 400) {

        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      } if (err.status == 500) {

        basicAlert('Error en el servicio, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
        this.spinnerService.activarLoading(false);
      }
    });
  }

  importarDatosSunat() {

    // if (this.objCliente.codcli == null || this.objCliente.codcli == "") {
    //   basicAlert('Debe seleccionar un cliente', 'warning', 'Aceptar');
    //   return;
    // }




    const referenciaModal = this.modalService.open(ImportarSunatComponent, { scrollable: true, backdrop: 'static' });
    referenciaModal.componentInstance.objImageSunat = this._sunatImage;
    referenciaModal.componentInstance.ruc = this.objCliente.dident;
    referenciaModal.result.then((data) => {
      console.log("se importo")
      console.log(data);

      this.objCliente.codtpe = 2;
      this.objCliente.tident = '06';
      this.objCliente.dident = data.ruc;
      this.objCliente.direc1 = data.direc;
      this.objCliente.razonc = data.razonc;


      this.getByCodInterlocutor(this.objCliente.dident);

    }, (reason) => {
      console.log("reason");
      console.log(reason);
    });



  }





  onChangeFinanciera() {
    this.disabledTipoCuenta = false;
  }

  onChangeTipoCuenta() {
    this.disabledMoneda = false;
    this.disabledBotonBanco = false;
  }

  //------------------ SECCIÓN DE ELIMINAR -------------------/// 
  EliminarClase(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el cliente?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {

          this.spinnerService.activarLoading(true);
          this.clienteService.eliminarClase(this.objCliente.codcli, data.clase).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.clases = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.clases = response.body.clases;
              if (this.clases.find(x => x.clase == 14) == null) {
                // basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
                //obteniendo la descripcion del codigo en desCodigoClase
                console.log("CLASE CLASES 132")
                this.Ubigeobloc = false;
              }
              else {
                this.Ubigeobloc = true;
              }
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });

          this.clases = [...this.clases]

        }

        this.modalService.dismissAll();

      })
  }
  EliminarCodPago(data: any) {

    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert: any) => {

        console.log(responseAlert);

        if (responseAlert != undefined && responseAlert != null && responseAlert) {

          if (data.esNuevo != null && data.esNuevo) {

            let _condiciones: any = this.condicionesPago.filter(x => x.codpag != data.codpag);
            if (_condiciones != null) {

              console.log(_condiciones);


              this.condicionesPago = _condiciones;
            }

          } else {
            this.spinnerService.activarLoading(true);
            this.clienteService.eliminar_codpag(this.objCliente.codcli, data.codpag)
              .subscribe((response: any) => {
                this.spinnerService.activarLoading(false);
                basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
                this.condicionesPago = [];
                this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
                  this.condicionesPago = response.body.condicionespago;
                }, err => {
                  this.spinnerService.activarLoading(false);
                  console.log(err);
                });
              }, err => {
                this.spinnerService.activarLoading(false);
                console.log(err.error.mensaje);
                basicAlert(err.error, 'success', 'Aceptar');
              });

          }



          // this.condicionesPago = [...this.condicionesPago]


        }
        this.modalService.dismissAll();
      })
  }

  EliminarContacto(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {


        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_contacto(this.objCliente.codcli, data.codcont).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.contactos = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.contactos = response.body.contactos;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.contactos = [...this.contactos]
        }
        this.modalService.dismissAll();

      })
  }

  EliminarEspecificacion(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_especificacion(this.objCliente.codcli, data.codesp).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.especificaciones = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.especificaciones = response.body.especificaciones;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
            this.selectModalNuevo();
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.especificaciones = [...this.especificaciones]
        }



        this.modalService.dismissAll();
      })
  }

  EliminarDireccion(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_direcciones_envio(this.objCliente.codcli, data.codenv).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.direcciones = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.direcciones = response.body.direccionesenvio;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });
          this.direcciones = [...this.direcciones]
        }


        this.modalService.dismissAll();
      })
  }

  EliminarBanco(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          this.spinnerService.activarLoading(true);
          this.clienteService.eliminar_bancos(this.objCliente.codcli, data.codban, data.tipcta, data.tipmon).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.bancos = [];
            this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
              this.bancos = response.body.bancos;
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'warning', 'Aceptar');
          });
          this.bancos = [...this.bancos]
        }


        this.modalService.dismissAll();
      })
  }
  ///////////////////////////////////////////////////////////////



  onCLickEspecificacion(data: any) {
    this.tipoConfirmar = 'InsertEspecificacion';
    console.log(data);
    this.codEspecificacion = data.codigo;
    this.desEspecificacion = data.descri;
    this.disabledDecimal = data.vreal;
    this.disabledTexto = data.vstrg;
    this.disabledCaracter = data.vchar;
    this.disabledFecha = data.vdate;
    this.disabledTiempo = data.vtime;
    this.disabledNumero = data.ventero;
  }

  guardarEspecificacion() {


    this.especificacion.forEach(element => {
      if (element.codigo == this.codEspecificacion) {
        console.log(element)
        this.desEspecificacion = element.descri;
      }
    });

    this.EspecifiacionTemp = new ClienteEspecificaciones();
    this.EspecifiacionTemp.codesp = this.codEspecificacion;
    this.EspecifiacionTemp.descri = this.desEspecificacion;

    this.EspecifiacionTemp.vreal = this.decimal;
    this.EspecifiacionTemp.vstrg = this.texto;
    this.EspecifiacionTemp.vchar = this.caracter;
    this.EspecifiacionTemp.vdate = this.fecha != '' ? moment(this.fecha).format("YYYY-MM-DD") : '';
    this.EspecifiacionTemp.vtime = this.tiempo;
    this.EspecifiacionTemp.ventero = this.numero;

    this.especificaciones.push(this.EspecifiacionTemp);
    this.especificaciones = [...this.especificaciones]
    this.modalService.dismissAll();
    console.log("Especificacion temporal a guardar")
    this.tableespecificaciones = this.especificaciones;
    console.log(this.EspecifiacionTemp)

    this.codEspecificacion = null;
    this.desEspecificacion = null;
    this.decimal = null;
    this.texto = null;
    this.caracter = null;
    this.tiempo = null;
    this.numero = null;

    this.tipoConfirmar = 'Insert';

    new ClienteEspecificaciones();
    this.borrarDatosInset();
    this.selectModalNuevo();
  }

  eliminarCliente() {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {
        if (responseAlert != undefined && responseAlert != null && responseAlert) {
          if (this.objCliente != null && this.objCliente.codcli != null) {
            this.spinnerService.activarLoading(true);
            this.clienteService.eliminar(this.objCliente.codcli).subscribe((resp: any) => {
              this.spinnerService.activarLoading(false);

              basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
              this.borrarDatos();
              this.buscarLimpiarBoton = 'buscar';
              this.dataService.vista = 0;

              this.mostrar = false;
              this.ParamDocumento = new Cliente();
              this.vista = 1;

            }, err => {
              this.spinnerService.activarLoading(false);
              basicAlert(err.error, 'warning', 'Aceptar', null, null);
            })
          }
        }
        this.modalService.dismissAll();
      })
  }

  guardarBanco() {
    if (this.codBanco == null) {
      basicAlert("El campo 'Financiera' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.codTipoCuenta == null) {
      basicAlert("El campo 'Tipo cuenta' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.codMoneda == '') {
      basicAlert("El campo 'Moneda' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.desCuenta == '') {
      basicAlert("El campo 'N° cuenta' es obligatorio.", 'warning', 'Aceptar');
      return;
    }

    this.BancoTemp = new ClienteBancos();
    this.BancoTemp.codban = this.codBanco;
    this.financieras.forEach(element => {
      if (element.codigo == this.codBanco) {
        console.log(element)
        this.desBanco = element.descri;
      }
    });
    this.BancoTemp.desban = this.desBanco;


    /////////////////////////////////////////////
    this.BancoTemp.tipcta = this.codTipoCuenta;
    this.tipocuentas.forEach(element => {
      if (element.codigo == this.codTipoCuenta) {
        console.log(element)
        this.desTipoCuenta = element.descri;
      }
    });
    this.BancoTemp.descta = this.desTipoCuenta;
    this.BancoTemp.tipmon = this.codMoneda;
    this.BancoTemp.cuenta = this.desCuenta;

    this.spinnerService.activarLoading(true);
    this.clienteService.insertar_bancos(this.objCliente.codcli, this.BancoTemp).subscribe((response: any) => {
      basicAlert('Se registró correctamente', 'success', 'Aceptar', null, null,);
      console.log(response);
      this.spinnerService.activarLoading(false);

      this.codBanco = null;
      this.desBanco = '';
      this.codTipoCuenta = null;
      this.desTipoCuenta = null;
      this.codMoneda = '';
      this.desCuenta = null;


      this.bancos = [...this.bancos]
      this.modalService.dismissAll();
      console.log("Clase temporal a guardar")
      this.tablebancos = this.bancos;
      this.BancoTemp = new ClienteBancos();
      this.borrarDatosInset();

      this.spinnerService.activarLoading(true);
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.spinnerService.activarLoading(false);
        this.bancos = response.body.bancos;
        console.log(this.bancos);
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
        if (err.status == 404) {
          basicAlert('Cliente no encontrado', 'warning', 'Aceptar');
        }
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 500) {
        basicAlert('Servicio no disponible, por favor comuniquese con el administrador del sistema', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })



  }




  AbrirModificarEspecificacion(content6: string, cla: any) {
    console.log("Especificación que se modificara")
    console.log(cla)

    this.disabledDecimalUpd = false;
    this.disabledTextoUpd = false;
    this.disabledCaracterUpd = false;
    this.disabledFechaUpd = false;
    this.disabledTiempoUpd = false;
    this.disabledNumeroUpd = false;
    //this.obtenerListaClasesCodigos(cla.clase);
    this.desEspecificacionUpd = cla.descri
    this.decimalUpd = cla.vreal;
    this.textoUpd = cla.vstrg;
    this.caracterUpd = cla.vchar;
    this.fechaUpd = cla.vdate;
    this.tiempoUpd = cla.vtime;
    this.numeroUpd = cla.ventero;

    if (cla.vreal != null) {
      this.disabledDecimalUpd = true;
    }
    if (cla.vstrg != null) {
      this.disabledTextoUpd = true;
    }
    if (cla.vchar != null) {
      this.disabledCaracterUpd = true;
    }
    if (cla.vtime != null) {
      this.disabledTiempoUpd = true;
    }
    if (cla.ventero != null) {
      this.disabledNumeroUpd = true;
    }

    this.editespecificacion = cla;


    this.modalService.open(content6, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }



  AbrirModificarBanco(content: string, cla: any) {
    console.log("Dirección que se modificara")
    console.log(cla)

    //this.obtenerListaClasesCodigos(cla.clase);
    this.codBancoUpd = cla.codban;
    this.desBancoUpd = cla.desban;
    this.codTipoCuentaUpd = cla.tipcta;
    this.desTipoCuentaUpd = cla.descta;
    this.codMonedaUpd = cla.tipmon;
    //this.desMonedaUpd = cla.ventero;
    this.desCuentaUpd = cla.cuenta;

    this.editbanco = cla;


    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
  }

  ModificarEspecificacion() {
    console.log(this.especificaciones)
    let arreglo = this.especificaciones;
    let indice = arreglo.indexOf(this.editespecificacion)

    console.log(indice)

    arreglo[indice].vreal = this.decimalUpd;
    arreglo[indice].vstrg = this.textoUpd;
    arreglo[indice].vchar = this.caracterUpd;
    arreglo[indice].vdate = this.fechaUpd;
    arreglo[indice].vtime = this.tiempoUpd;
    arreglo[indice].ventero = this.numeroUpd;


    console.log("Especificaciones modificado");
    console.log(arreglo)
    this.especificaciones = arreglo
    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modalService.dismissAll();
  }

  decimalFormatLimiteCredito(dato: any) {
    let lengthtext: any = +this.decimalPrecio + 4
    if (dato.length > lengthtext) {
      let datoreplace = dato.replace(',', '')
      this.objCliente.limiteCredito = parseFloat(datoreplace);
    } else {
      this.objCliente.limiteCredito = parseFloat(dato);
    }
    this.viewlimiteCredito = this.decimalPipe.transform(this.objCliente.limiteCredito, `0.${this.decimalPrecio}-${this.decimalPrecio}`);
  }


  modificarBanco() {
    let bancomod: ClienteBancos = {

      codban: this.codBancoUpd,
      desban: this.desBancoUpd,
      tipcta: this.codTipoCuentaUpd,
      descta: this.desTipoCuentaUpd,
      tipmon: this.codMonedaUpd,
      cuenta: this.desCuentaUpd,
      id_cia: null,
    }

    this.spinnerService.activarLoading(true);
    this.clienteService.actualizar_bancos(this.objCliente.codcli, bancomod).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      basicAlert('Se modificó con éxito.', 'success', 'Aceptar', null, null);
      this.bancos = [];
      this.interlocutorService.obtenerInterlocutor(this.objCliente.codcli, null).subscribe((response: any) => {
        this.bancos = response.body.bancos;
      }, err => {
        this.spinnerService.activarLoading(false);
        console.log(err);
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err.error.mensaje);
      basicAlert(err.error, 'warning', 'Aceptar');
    });
    this.bancos = [...this.bancos]
    this.modalService.dismissAll();

  }

  selectModalNuevo() {
    this.interlocutorService.getEspecificaciones().subscribe(response => {
      let espec = response.body;
      this.especificaciones.forEach(element => {
        espec = espec.filter(function (dato) {
          if (dato.codigo == element.codesp) {
            return false;
          } else {
            return true;
          }
        });
      });
      console.log('ARREGLO FINAL SELECT:')
      console.log(espec);
      this.especificacion = espec;
    })
  }

  onSelectTipoIdentidadIns(tipid: string) {
    //evaluando tipo de identidad
    console.log("evaluando tipo de identidad");
    console.log(tipid);
    if (tipid == "01") {
      this.identidad = false
      this.isnatural = false
    } else {
      this.identidad = true
      this.isnatural = true
      this.objCliente.nrodni = null
      this.objCliente.nrodni = ""
    }
    this.identidades.forEach(element => {
      if (element.tident == tipid) {
        console.log(element)
        this.tamanoidentidad = element.tamano;
      }
    });
    console.log(this.tamanoidentidad);
  }

  onKeyUpNombresCompletos(event: any) {

    this.quitarEspaciosEnBlanco(event.target.value);
    console.log(event.target.value);
    let separacion = event.target.value.replace("  ", " ")

    let NOMBRES = separacion.split(" ");

    if (separacion == '') {
      NOMBRES = [];
    }

    if (NOMBRES.length == 0) {
      this.objCliente.nombres = '';
      this.objCliente.apellidopaterno = '';
      this.objCliente.apeliidomaterno = '';
    }

    if (NOMBRES.length == 1) {
      this.objCliente.apellidopaterno = '';
      this.objCliente.apeliidomaterno = '';
      this.objCliente.nombres = NOMBRES[0];
    }

    if (NOMBRES.length == 2) {
      this.objCliente.apeliidomaterno = '';
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.nombres = NOMBRES[1];
    }

    if (NOMBRES.length == 3) {
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.apeliidomaterno = NOMBRES[1];
      this.objCliente.nombres = NOMBRES[2];
    }

    if (NOMBRES.length == 4) {
      this.objCliente.apellidopaterno = NOMBRES[0];
      this.objCliente.apeliidomaterno = NOMBRES[1];
      this.objCliente.nombres = NOMBRES[2] + ' ' + NOMBRES[3];
    }
  }
  quitarEspaciosEnBlanco(cadena: string) {
    let espaciosVacios: number = 0;
    for (let index = 0; index < cadena.length; index++) {
      const element = cadena[0];
      if (element == ' ') {
        espaciosVacios = 1;
      }
    }
    //nombresyapellidos
    this.objCliente.razonc = cadena.replace(cadena.substring(0, espaciosVacios), '');
    if (cadena.includes('  ')) {
      this.objCliente.razonc = cadena.replace('  ', ' ')
    }
  }

  cerrar(): void {
    this.modalService2.dismiss('canceling');
  }

  onNexFocus(tipo: string) {
    if (tipo == 'nuevo') {
      timerOut(10).then((value: any) => {
        if (value) { this.selectTipoInventario.nativeElement.focus(); }
      })
    }
    if (tipo == 'modificar') {
      timerOut(10).then((value: any) => {
        if (value) { this.modificar.nativeElement.focus(); }
      })
    }
  }
  borrarDatosArticulo() {
    this.borrarArticulo();
    this.cancelar();

    timerOut(10).then((value: any) => {
      if (value) { this.desarticulo.nativeElement.focus(); }
    });


    this.disabledArticulo = false;
    this.buscarArticulo = 'buscar';
    this.dataService.vista = 0;

  }
  borrarArticulo() {

    this.objarticulo.codart = ''
    this.objarticulo.descri = ''
    this.tituloarticulo = ''
  }
  cancelar() {
    this.listaStockPorAlmacen = []
    this.stocktotalFisico = 0;
    this.stocktotalComprom = 0;
    this.stockTotalDisponi = 0;
    this.stockTotalPorRecibir = 0;
    this.stockTotalImportacion = 0;

    this.objarticulo.codprv = ''
    this.desProveedor = ''
    this.updatebandera = false;
    this.mostrarbotoneliminar = true

    this.tabclases = false;
    this.tabespecificaciones = false;
    this.tabimagenes = false;
    this.tabclasesglobales = false;
    this.tablistprecios = false;
    this.tabCotizaciones = false;
    this.tabVentas = false;
    this.tabCompras = false;
    this.tabLprecioProv = false;
    this.tabComprometido = false;
    this.tabXrecibir = false;

    let lasTipinv: number = this.objarticulo.tipinv;

    this.objarticulo = new objArticulo()
    this.clases = []
    this.objarticulo.tipinv = lasTipinv;
    this.objarticulo.fmatri = obtenerFechaActual('YYYY-MM-DD')
    this.objarticulo.faccon = (Number.parseFloat('1').toFixed(4));
    this.objarticulo.consto = 1;

    this.inputAgrupa = false;
    this.inputPagoAdelantado = false;

    this.disabledArticulo = false;
    this.buscarArticulo = 'buscar';
    this.dataService.vista = 0;

    this.disabledProveedor = false;
    this.buscarProveedor = 'buscar';

    this.tipoControlStock.forEach(element => {
      if (element.codigo == this.objarticulo.consto) {
        console.log(element.descri);
        this.desControlStock = element.descri;
      }
    });

    this.disabledcampo = true;
    this.disabledTipoInventario = false;

    timerOut(3).then((value: any) => {
      if (value) { this.desarticulo.nativeElement.focus(); }
    });

    this.imagenesArticulo = [];
    this.objImagen = new ImagenBase64();
    this.codImagen = ''
    this.disabledbotonImagen = true;

  }
  onKeyEnterArticulo(e) {
    this.openModalArticulo();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }
  openModalArticulo() {
    let codpro: string = '';
    let razonc: string = this.objarticulo.descri + "%";
    let limit: number = 60;
    let offset: number = 0;

    console.log(this.objarticulo.tipinv + razonc)

    if (this.objarticulo.descri.length > 0) {
      this.spinnerService.activarLoading(true);
      this.articuloService.buscar(this.objarticulo.tipinv, codpro, razonc, limit, offset).subscribe((response: any) => {
        console.log('lista de articulos')
        console.log(response.body);
        this.articulos = response.body;
        this.mostrarModalArticulo();
      }, err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No se encontró la lista de articulos.', 'warning', 'Aceptar', null, null, this.razon);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter.', 'warning', 'Aceptar', null, null, this.razon);
      return;
    }
  }
  
  onKeyEnterCodigoArticulo(e) {
    this.openModalCodArticulo();

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }
  openModalCodArticulo() {
    let codpro: string = this.objarticulo.codart+"%";
    let razonc: string = '';
    let limit: number = 60;
    let offset: number = 0;

    if (this.objarticulo.codart.length > 0) {
      this.spinnerService.activarLoading(true);
      this.articuloService.buscar(this.objarticulo.tipinv, codpro, razonc, limit, offset).subscribe((response: any) => {
        console.log('lista de articulos')
        console.log(response.body);
        this.articulos = response.body;
        if(this.articulos.length >1){
          this.mostrarModalArticulo();
        }else{
          console.log(this.articulos[0])
          this.objarticulo.codart = this.articulos[0].codart
          this.onBlurCodArticulo(this.objarticulo.codart)
        }
      
      }, err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No se encontró la lista de articulos.', 'warning', 'Aceptar', null, null, this.razon);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter.', 'warning', 'Aceptar', null, null, this.razon);
      return;
    }
  }
  mostrarModalArticulo() {
    const referenciaModal = this.modalService.open(ModalBusquedaArticulosComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
    referenciaModal.componentInstance.articulos = this.articulos;
    referenciaModal.result.then((data) => {
      console.log(data);
      this.getByCodArticulo(data.tipinv, data.codart, 2)
    }, (reason) => {
      console.log(reason);
    });
  }
  getByCodArticulo(tipinv: number, codart: string, tipoSearch: number) {
    this.spinnerService.activarLoading(true);
    this.sessionInfo = JSON.parse(StorageService.getSession());
    this.articuloService.obtener_articulo(tipinv, codart).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log('Informacion sesion:---')
      console.log(this.sessionInfo)
      this.tituloarticulo = response.body.codart + ' - ' + response.body.descri
      this.objarticulo.codart = response.body.codart
      this.objarticulo.descri = response.body.descri
      this.objarticulo.fmatri = response.body.fmatri
      this.objarticulo.codbar = response.body.codbar
      this.objarticulo.agrupa = response.body.agrupa
      this.objarticulo.consto = response.body.consto
      this.objarticulo.coduni = response.body.coduni
      this.objarticulo.proart = response.body.proart
      this.objarticulo.wglosa = response.body.wglosa
      this.objarticulo.conesp = response.body.conesp

      this.mostrarbotoneliminar = false;
      this.tabclases = true;
      this.tabespecificaciones = true;
      this.tabimagenes = true;
      this.tabclasesglobales = true;
      this.tablistprecios = true;
      this.tabCotizaciones = true;
      this.tabVentas = true;
      this.tabCompras = true;
      this.tabLprecioProv = true;
      this.tabComprometido = true;
      this.tabXrecibir = true;

      this.disabledcampo = false;
      this.disabledProveedor = false;
      this.disabledTipoInventario = true;

      //INFORMACION DE TABS

      if (response.body.clases != null) {
        this.clases = response.body.clases;
      }
      if (response.body.especificaciones != null) {
        this.especificaciones = response.body.especificaciones;
      }
      if (response.body.especificaciones != null) {
        this.clasesGlobales = response.body.clasesglobal;
      }

      if (response.body.codprv != null)
        this.getByCodProveedor(response.body.codprv, 2)
      this.asignarDecimalesFacConversion(response.body.faccon)
      this.selectModalEspecificacion();
      this.getlistaPrecioArticulos(tipinv, codart)
      this.getStockPorAlmacen(tipinv, codart)
      this.articuloService.listaArticuloImagenes(this.codTipoInventario, this.objarticulo.codart).subscribe((response: any) => {
        console.log(response);
        this.imagenesArticulo = response.body;
        console.log(this.imagenesArticulo)
      })
      //this.getImagen(tipinv,codart)

      this.tipoControlStock.forEach(element => {
        if (element.tipo == response.body.consto) {
          this.desControlStock = element.descripcion;
        }
      });

      if (this.objarticulo.agrupa == 'S') {
        this.inputAgrupa = true;
      } else {
        this.inputAgrupa = false;
      }

      if (this.objarticulo.conesp == 1) {
        this.inputPagoAdelantado = true;
      } else {
        this.inputPagoAdelantado = false;
      }
      timerOut(10).then((value: any) => {
        if (value) { this.selectunidadesMedidas.nativeElement.focus(); }
      });

      this.disabledArticulo = true;
      this.buscarArticulo = 'borrar';

      this.dataService.vista = 1;
      this.dataService.tipo = 'articulo';
      this.onNexFocus('modificar');

      this.spinnerService.activarLoading(false);
    }, err => {
      this.spinnerService.activarLoading(false);
      if (err.status == 404) {
        basicAlert('No se encontró información para el articulo seleccionado', 'warning', 'Aceptar');
        this.mostrarbotoneliminar = true;
      }
      timerOut(10).then((value: any) => {
        if (value) { this.provee.nativeElement.focus(); }
      });
      this.objarticulo.codart = ''
      this.objarticulo.descri = ''
    });
  }
  onBlurCodArticulo(codart: string) {
    if (codart != '') {
      this.getByCodArticulo(this.objarticulo.tipinv, codart, 2);
    }
  }
  getByCodProveedor(codpro: string, tipoSearch: number) {
    this.spinnerService.activarLoading(true);
    this.provedorService.obtenerProveedor(codpro, true).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.updatebandera = true;
      this.objarticulo.codprv = response.body.codcli
      this.desProveedor = response.body.razonc
      this.disabledProveedor = true;
      this.buscarProveedor = 'borrar';
    }, err => {
      this.updatebandera = false
      this.spinnerService.activarLoading(false);
      console.log(err);
      if (err.status == 404) {
      }
      this.objarticulo.codprv = ''
      this.desProveedor = ''

    });
  }
  /*************************TIPO DE INVENTARIO*************************************/
  onKeyEnterTipodeInventario(e) {
    if (this.objarticulo.tipinv != null) {

      if (e.which == 13) {
        if ($('#cboTipoInventario option:selected').text() == '') {
          this.objarticulo.tipinv = 1;
          setTimeout(() => {
            basicAlert('El código ingresado no existe.', 'warning', 'Aceptar', null, null, null);
          }, 200);
        }
      }
      /*let tecla: any;
      tecla = (document.all) ? e.keyCode : e.which;
      return (tecla != 13); */
    }
  }

  onBlurTipodeInventario(e) {
    console.log('onBlurTipodeInventario')
    if (this.objarticulo.tipinv != null) {
      if (e.which == 0) {
        //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
        if ($('#cboTipoInventario option:selected').text() == '') {
          this.objarticulo.tipinv = 1;
          basicAlert('El código ingresado no existe.', 'warning', 'Aceptar', null, null, null);
        }
      }
    }
  }
  asignarDecimalesFacConversion(val: any) {
    this.objarticulo.faccon = (Number.parseFloat(val).toFixed(4));
  }
  selectModalEspecificacion() {

    // this.articuloService.listEspecificaciones(this.objarticulo.tipinv).subscribe(response => {
    this.articuloService.listEspecificaciones(this.objarticulo.tipinv).subscribe(response => {
      let clasestemp = response.body;
      if (this.especificaciones != null) {
        this.especificaciones.forEach(element => {
          clasestemp = clasestemp.filter(function (dato) {
            if (dato.codigo == element.codesp) {
              //console.log("SI existe")
              return false;
            } else {
              //   console.log("SI existe")
              return true;
            }
          });
        });
      }
      console.log('arreglo select especificacion:')
      console.log(clasestemp)
      this.clasesSelectEspecificaciones = clasestemp;

    })
  }
  getlistaPrecioArticulos(tipinv: number, codart: string) {
    this.articuloService.listPrecios(tipinv, codart).subscribe((resp: any) => {

      console.log('La lista de precios es: ...');
      console.log(resp.body);
      this.listaPreciosArticulo = resp.body.list;
    }, err => {

    })
  }
  getStockPorAlmacen(tipinv: number, codart: string) {
    this.articuloService.getStockv2(tipinv, codart, 0).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      if (response.body != null)
        this.listaStockPorAlmacen = response.body;
      this.listaStockPorAlmacen.forEach(element => {
        this.stocktotalFisico += element.stockFisico
        this.stocktotalComprom += element.stockComprometido
        this.stockTotalDisponi += element.stockDisponible
        this.stockTotalPorRecibir += element.stockPorRecibir
        this.stockTotalImportacion += element.stockImportacion
      });
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err)
    });

  }
  buscarVentas() {

    let query: any = {
      tipinv: this.objarticulo.tipinv,
      codart: this.objarticulo.codart,
      codsuc: this._codSucursal,
      codcli: this.objCliente.codcli,
      fdesde: this.desde,
      fhasta: this.fechaHasta1,
      limit: 100,
      offset: 0
    };
    console.log("this.qery")
   console.log(query);
    this.spinnerService.activarLoading(true);
    this.articuloService.sp_articulo_ventas(query).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);

      this.sp_ventas = response.body;
      console.log("Sp Ventas");
      console.log('Sp Ventas',this.sp_ventas);
    }, err => {
      this.sp_ventas = [];

      basicAlert("No hay resultados", 'warning', 'Aceptar');

      this.spinnerService.activarLoading(false);
    });

  }


   //Guias de remision
   onChange(option: string, isChecked: boolean) {
    if (isChecked) {
      this.newSituaciones.push(option);
    } else {
      this.newSituaciones = this.newSituaciones.filter(s => s !== option);
      this.check = false;
    }
    if (this.newSituaciones.length == this.situaciones.length) {
      this.check = true
    }
    console.log(this.newSituaciones)
  }
  onChange2(option: string, isChecked: boolean) {
    if (isChecked) {
      this.newSituaciones2.push(option);
    } else {
      this.newSituaciones2 = this.newSituaciones2.filter(s => s !== option);
      this.check2 = false;
    }
    if (this.newSituaciones2.length == this.situaciones2.length) {
      this.check2 = true
    }
    console.log(this.newSituaciones2)
  }
  onKeyEnterVendedor(e) {
    if (this.codVendedor != null) {
      setTimeout(() => {
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurVendedor(e) {
    console.log(this.codVendedor);
    if (this.codVendedor != null) {
      if (e.which == 0) {
        if ($('#cboVendedor option:selected').text() == '') {
          this.codVendedor = null;
        }
      }
    }
  }
  private getVendedor() {
    this.vendedores = this.sessionInfo.vendedores;
  }
  onKeyEnterSucursal(e) {
    if (this.codSucursal != null) {
      setTimeout(() => {
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurSucursal(e) {
    if (this.codSucursal != null) {
      if (e.which == 0) {
        if ($('#cboSucursal option:selected').text() == '') {
          this.codSucursal = null;
        }
      }
    }
  }
  private getSucursal() {

    this.sucursales = this.sessionInfo.sucursales;
    if (this.sucursales != null && this.sucursales.length > 0)
      this.codSucursal = this.sessionInfo.codsuc;
  }
  /********************************MOTIVO******************/

  onKeyEnterMotivo(e) {
    if (this.codMotivo != null) {
      setTimeout(() => {
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurMotivo(e) {
    if (this.codMotivo != null) {
      if (e.which == 0) {
        if ($('#cboMotivo option:selected').text() == '') {
          this.codMotivo = null;
        }
      }
    }
  }
  private getMotivos() {
    let tipdoc = 101
    let motivo = 'S'
    this._buscarService.motivos(tipdoc, motivo).subscribe((resp: any) => {
      console.log(resp.body.list);
      this.motivos = resp.body.list;
    }, err => {
      console.log(err)
    })
  }
  /********************************SUNAT******************/

  onKeyEnterSunat(e) {
    if (this.codSunat != null) {
      setTimeout(() => {
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurSunat(e) {
    if (this.codSunat != null) {
      if (e.which == 0) {
        if ($('#cboSunat option:selected').text() == '') {
          this.codSunat = null;
        }
      }
    }
  }
  private getSunat() {

    this.SunnatService.getsunat().subscribe((resp: any) => {
      console.log(resp.body.list);
      this.sunatlist = resp.body.list;
    }, err => {
      console.log(err)
    })
  }
  imprimir(data: any) {

    this.spinnerService.activarLoading(true);
    this.gremisionService.descargarPDF(data.numint, this.sessionInfo.cia).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } else {
        basicAlert('No hay resultados.', 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err)
      this.spinnerService.activarLoading(false);
      basicAlert('Impresión de documento no disponible.', 'warning', 'Aceptar', null, null, null);
    });
  }
  anular(data: any) {
    alertaConfirmacion('¿Está seguro de anular este documento?', 'warning', false, true).then((responseAlert) => {
      if (responseAlert) {
        this.spinnerService.activarLoading(true);
        this.gremisionService.anular(data.numint, this.sessionInfo.coduser,'').subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          basicAlert("Se anuló correctamente.", 'success', 'Aceptar', null, null, null);
          this.consultar();
        }, err => {
          this.spinnerService.activarLoading(false);
          basicAlert(err.error, 'warning', 'Aceptar', null, null, null);
        });
      }
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }
  consultar() {
    let limit = 1000
    let offset = 0
    console.log(this.fechaDesde)
    console.log('Este es el metodo consultar.......')
    console.log(this.fechaDesde + '-' + this.fechaHasta + '-' + this.newSituaciones.toString() + '-' + this.codLugarEmision + '-' + limit + '-' + offset)
    console.log(this.codVendedor + '--' + this.codSucursal + '--' + this.cotizacionmodel.codInterlocutor)

    if (this.newSituaciones.toString() == "") {
      // basicAlert('Debe seleccionar una o mas situaciones.', 'warning', 'Aceptar', null, null, null);
      this.toastr.warning('Debe seleccionar una o mas situaciones.');
      return;
    }

    if (this.fechaDesde > this.fechaHasta) {
      //basicAlert('Fecha desde no puede ser mayor que la fecha hasta.', 'warning', 'Aceptar', null, null, null);
      this.toastr.warning('Fecha desde no puede ser mayor que la fecha hasta.')
      return;
    }

    if (this.fechaDesde == undefined || this.fechaDesde.toString() === 'Invalid date' || this.fechaHasta.toString() === 'Invalid date') {
      //basicAlert('Verificar las fechas ingresadas.', 'warning', 'Aceptar', null, null, null);
      this.toastr.warning('Verificar las fechas ingresadas.')
      return;
    }

    // if ($("#cboSucursal option:selected").text() == "") {
    //   //basicAlert('El código de sucursal no existe.', 'warning', 'Aceptar', null, null, null);
    //   this.toastr.warning('El código de sucursal no existe.')
    //   return;
    // }

    // if ($("#cboVendedor option:selected").text() == "") {
    //   //basicAlert('El código de vendedor no existe.', 'warning', 'Aceptar', null, null, null);
    //   this.toastr.warning('El código de vendedor no existe.')
    //   return;
    // }

    let _parasm = {
      fdesde: this.fechaDesde,
      fhasta: this.fechaHasta,
      situac: this.newSituaciones.toString(),
      codcli: this.objCliente.codcli,
      estadoSunat: this.codSunat,
      codmot: this.codMotivo,
      codsuc: this.codSucursal,
      codven: this.codVendedor,
      limit: 1000,
      offset: 0
    }

    this.spinnerService.activarLoading(true);
    this.gremisionService.guiasRemision(_parasm).subscribe((resp: any) => {
      console.log(resp)
      this.spinnerService.activarLoading(false);
      this.cotizaciones = resp.body;
      this.resultados = false
      this.formulario = true
    }, err => {
      this.spinnerService.activarLoading(false);
      // basicAlert('No se encontró resultados según los filtros seleccionados .', 'warning', 'Aceptar', null, null, null);
      this.toastr.warning('No se encontró resultados según los filtros seleccionados.')
      this.resultados = true;
      this.formulario = false;
    })
  }
  eliminar(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar este documento?', 'warning', false, true).then((responseAlert) => {
      if (responseAlert) {
        this.spinnerService.activarLoading(true);
        this.gremisionService.eliminar(data.numint, this.sessionInfo.coduser).subscribe((response: any) => {
          this.spinnerService.activarLoading(false);
          console.log(response);
          basicAlert("Se eliminó correctamente.", 'success', 'Aceptar', null, null, null);
          this.consultar();
        }, err => {
          console.log(err)
          this.spinnerService.activarLoading(false);
          basicAlert(err.error, 'warning', 'Aceptar', null, null, null);
        });
      }
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }
  sendSunat(doc: any) {

    this.spinnerService.activarLoading(true);
    this.enviosFEService.send_sunat(this.sessionInfo.id_cia, doc.tipdoc, doc.numint).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      console.log(resp.body);
      if (resp.body != null && resp.body.responseCode == "0") {
        basicAlert(resp.body.responseDescription, 'success', 'Aceptar', null, null, null);
        this.consultar();
      } else {
        basicAlert(resp.body.responseDescription + " " + resp.body.responseCode, 'warning', 'Aceptar', null, null, null);
      }
    }, err => {
      console.log(err.error);
      this.spinnerService.activarLoading(false);
      basicAlert("Servicio no disponible, consulte con el administrador del sistema.", 'warning', 'Aceptar', null, null, null);
    })

  }
  download_xml(doc: any) {
    this.spinnerService.activarLoading(true);
    this.docCabService.descargarXML(this.sessionInfo.id_cia, doc.numint)
      .subscribe((response: any) => {
        console.log(response)
        if (response.byteLength > 0) {
          let file = new Blob([response], { type: 'application/zip' });
          var fileURL = URL.createObjectURL(file);
          FileSaver.saveAs(fileURL, "Comprobante_XML" + '.zip');
        } else {
          basicAlert('No hay resultados', 'warning', 'Aceptar');
        }
        this.spinnerService.activarLoading(false);
      }, err => {
        console.log(err)
        basicAlert('No hay resultados', 'warning', 'Aceptar');
        this.spinnerService.activarLoading(false);
      })
  }
  download_cdr(doc: any) {
    this.spinnerService.activarLoading(true);
    this.docCabService.descargarCDR(this.sessionInfo.id_cia, doc.numint).subscribe((response: any) => {
      console.log(response)
      if (response.byteLength > 0) {
        let file = new Blob([response], { type: 'application/zip' });
        var fileURL = URL.createObjectURL(file);
        FileSaver.saveAs(fileURL, "Comprobante_CDR" + '.zip');
      } else {
        basicAlert('No hay resultados', 'warning', 'Aceptar');
      }
      this.spinnerService.activarLoading(false);
    }, err => {
      basicAlert('No hay resultados', 'warning', 'Aceptar');
      this.spinnerService.activarLoading(false);
    })
  }
  doc_adjuntos: any[] = [];
  documentos_adjuntos(data: any) {
    this.spinnerService.activarLoading(false);
    const referenciaModal = this.modalService.open(ModalDocumentosAdjuntosCabComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });
    referenciaModal.componentInstance.doc_adjuntos = this.doc_adjuntos;
    referenciaModal.componentInstance.numint = data.numint;
  }
  openModalDocumento(data:any){
    
    this.spinnerService.activarLoading(true);
    this.documentoService.obtenerDetalleDocumento(data.numint, true).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.detalledocumento = response.body;
      this.mostrarModalDocumento();
    }, err => {
      console.log(err);
      if (err.status == 404) {
        basicAlert('No hay resultados', 'warning', 'Aceptar', null, null);
      }
      this.spinnerService.activarLoading(false);
    });
}
    mostrarModalDocumento(){
      const referenciaModal = this.modalService.open(MdDocumentoComponent, { scrollable: true, windowClass: 'md-full-size', backdrop: 'static' });
      referenciaModal.componentInstance.documento = this.detalledocumento;
      referenciaModal.componentInstance.encontrado = false;
      referenciaModal.componentInstance.enDoc=true;

    }
    disabledArticulos=false;
    articuloTodos=true;
    onChangeArticuloResumen(){
      if(this.articuloTodos==true){
            this.disabledArticulo=true;
            this.objarticulo.codart='';
            /* this._codSucursal=-1;
            this.objarticulo.tipinv=-1; */
            this.objarticulo.descri='';
      }else{
            this.disabledArticulo=false;
            this.buscarArticulo = 'buscar';
      }
    }
    
}
